import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
`;

export const AlertText = styled.span`
  color: ${props => props.theme.colors.negative};
`;

export const DepositoCurrencyInput = styled.input`
  width: 100%;
  padding: 14px;
  padding-left: 100px;
  font-size: 18px;
  border: none;
  outline: none;
  background: transparent;
  color: #333;
  font-weight: 500;
  
  &::placeholder {
    color: #aaa;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s ease;
  
  &:focus-within {
    border-color: #0077cc;
    box-shadow: 0 0 0 2px rgba(0, 119, 204, 0.2);
  }
  
  svg {
    position: absolute;
    left: 10px;
    z-index: 1;
  }
  
  input {
    padding-left: 10px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  height: 100%;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;
